import React, { useState } from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  
  const handleSubscribe = (e) => {
    e.preventDefault();
    alert('Thank you for subscribing!');
    setEmail('');
  };

  return (
    <footer className="bg-white pt-24 pb-12 border-t border-gray-100">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Address & Contact */}
          <div className="col-span-1 md:col-span-2 pr-8">
            <div className="flex items-center gap-3 mb-6">
              <img src="/assets/img/logo.png" alt="Easy Hiring Logo" className="h-10 w-auto object-contain" />
              <span className="font-display font-bold text-xl tracking-tight text-gray-900">Easy Hiring</span>
            </div>
            <h4 className="font-bold text-gray-900 mb-6 uppercase text-sm tracking-wider">Address</h4>
            <p className="text-gray-500 leading-relaxed mb-6 flex items-start gap-3">
              <MapPin className="w-5 h-5 flex-shrink-0 mt-1 text-blue-600" />
              <span>
                GVR Infra Rd Number 12, <br />
                Ayyappa Society, Madhapur, <br />
                Hyderabad, Telangana, India
              </span>
            </p>
            <p className="flex items-center gap-3 text-gray-500 mb-8">
              <Mail className="w-5 h-5 flex-shrink-0 text-blue-600" />
              <a href="mailto:info@easyhiring.in" className="hover:text-blue-600 transition-colors">info@easyhiring.in</a>
            </p>

            <h4 className="font-bold text-gray-900 mb-4 uppercase text-sm tracking-wider">Follow Us</h4>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/easyhiring-in/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-blue-50 hover:text-blue-600 transition-all duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.twitter.com/easyhiring_in/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-blue-50 hover:text-blue-600 transition-all duration-300">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/easyhiring.in/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-blue-50 hover:text-blue-600 transition-all duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/easyhiring.in/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:bg-blue-50 hover:text-blue-600 transition-all duration-300">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-gray-900 mb-6 uppercase text-xs tracking-wider">Quick Links</h4>
            <ul className="space-y-4">
              <li><Link to="/" className="text-gray-500 hover:text-blue-600 transition-colors">Home</Link></li>
              <li><Link to="/about-us" className="text-gray-500 hover:text-blue-600 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-500 hover:text-blue-600 transition-colors">Contact</Link></li>
              <li><a href="https://auth.easyhiring.in/refund" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-blue-600 transition-colors">Refund policy</a></li>
              <li><a href="https://auth.easyhiring.in/cancellation" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-blue-600 transition-colors">Cancellation policy</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-6 uppercase text-xs tracking-wider">Legal</h4>
            <ul className="space-y-4">
              <li><a href="https://auth.easyhiring.in/privacy" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-blue-600 transition-colors">Privacy policy</a></li>
              <li><a href="https://auth.easyhiring.in/terms" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-blue-600 transition-colors">Terms and conditions</a></li>
            </ul>
            
            <h4 className="font-bold text-gray-900 mt-8 mb-4 uppercase text-xs tracking-wider">Newsletter</h4>
            <p className="text-sm text-gray-500 mb-4">Subscribe for updates and offers.</p>
            <form 
              onSubmit={handleSubscribe}
              className="flex flex-col gap-2"
            >
              <input 
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name="EMAIL" 
                placeholder="Email Address" 
                required 
                className="input-field py-2 text-sm" 
              />
              <button type="submit" className="btn-primary py-2 text-sm w-full">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} Easy Hiring Infotech LLP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
